import React from "react";

import { useIntl } from "react-intl";
import { Routes, Route } from "react-router-dom";

import AppErrorBoundary from "Components/AppErrorBoundary";

import useOrganizationFromURL from "../settings/pages/members/hooks/useOrganizationFromURL";

import { BillingDetails } from "./BillingDetails";
import { Layout } from "./Layout";
import { Review } from "./Review";

const SubscribeRoutes = () => {
  const organization = useOrganizationFromURL();
  const intl = useIntl();
  if (!organization) return null;

  return (
    <AppErrorBoundary intl={intl}>
      <Layout>
        <Routes>
          <Route
            path="billing-details"
            element={<BillingDetails organization={organization} />}
          />
          <Route path="" element={<Review organization={organization} />} />
        </Routes>
      </Layout>
    </AppErrorBoundary>
  );
};

export default SubscribeRoutes;
